import React from 'react';
import { SkeletonGroupSkin } from './SkeletonGroup.types';

export const SkeletonGroupContext = React.createContext<
  undefined | { skin?: SkeletonGroupSkin | undefined }
>(undefined);
